import React from 'react';
import { Icon } from 'semantic-ui-react';
import {
  createdAt,
  coupons,
  name,
  nth,
  fullNameFromUserId,
  emailFromUserId,
  getPaymentStatusText,
} from '../../../common/utils';

// https://github.com/react-tools/react-table#columns
export const getColumns = () => {
  return [
    nth,
    createdAt,
    {
      Header: () => <Icon name='building'/>,
      accessor: 'company_name',
      maxWidth: 160
    },
    name,
    {
      Header: () => <Icon name='at'/>,
      accessor: 'email',
      maxWidth: 200
    },
    coupons,
    fullNameFromUserId,
    emailFromUserId,
    {
      Header: () => <Icon name='eur'/>,
      accessor: 'status',
      maxWidth: 100
    }
  ];
};

export const DEFAULTSORTED = [
  { id: 'created', desc: false },
  { id: 'family_name', desc: false }
];

export const DEFAULTPAGESIZE = 20;



// WEBPACK FOOTER //
// ./src/private/admin/components/PurchaseOrders/table.conf.js